// extracted by mini-css-extract-plugin
export default {"cls1":"useMenuActions-cls1__MY","cls2":"useMenuActions-cls2_d4g useMenuActions-cls1__MY"};